// extracted by mini-css-extract-plugin
export var currencyInput = "_ll-1";
export var currencySymbol = "_ll-0";